import styled from 'styled-components'
import { bp } from 'lib/core/resources/helpers/styled'

export const Wrapper = styled.div`
  overflow: hidden;

  .posts-grid {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    height: fit-content;
    ${bp('lg')`
      flex-direction: column;
    `}

    > div {
      box-sizing: border-box;
      border: 1px solid ${props => props.theme.palette.general.grey};
      border-radius: 5px;
      overflow: hidden;
      width: 48%;
      margin: 0 5px 20px;
      ${bp('lg')`
        width: 100%;
        margin: 0 0 15px;
      `}
    }
  }
`
